import _extends from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _asyncToGenerator from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "/home/node/app/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @format */

import 'babel-polyfill';
import 'url-search-params-polyfill';
import React from 'react';
import fetch from 'isomorphic-unfetch';
import { Provider, connect } from 'react-redux';
import App from 'next/app';
import queryString from 'query-string';
import config from "../utils/clientConfig";
import withApollo from "../containers/withApollo";
import withRedux from "../containers/withRedux";
import { ThemeProvider } from 'styled-components';
import { GlobalStyles, baseTheme } from "../constants/css";
import { syncOffersViewedState } from "../reducers/markAs";
import { syncMemberDetails, syncShoSession, logoutFromLsl, redirectToOauthLoginPage, setUserAuthenticatedOnRefresh, expireLslSession, logoutViaExpire, openNewUserModal, openOptInModal } from "../reducers/user";
import { getLslAccessTokenFromCookie, getLslSessionToken, getOAuthUserInfoFromCookie } from "../utils/loginHelper";
import TrackingUtilities from "../utils/trackingUtilities";
import pathNameHelper from "../utils/pathNameHelper";
import { OptimizelyProvider } from '@optimizely/react-sdk';
import Cookies from 'universal-cookie';
import { setToasterIndex, getToasterIndex, getCurrentPath, setMobileAppLandingPage, setChannel } from "../utils/sessionStorageHelper";
import { assembleToasters } from "../utils/checkToasters";
import GeneralHeader from "../components/Header";
import LinkCardHeader from "../components/Header/LinkCard";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import Outage from "../components/Outage";
import SubFooter from "../components/SubFooter";
import ImportantInfo from "../components/ImportantInfo";
import SkipLinks from "../components/SkipLinks";
import MemberProfile from "../components/Header/MemberProfile";
import BrowserModal from "../components/BrowserModal";
import _ from 'lodash';
import { createEvent, track } from "../lib/google-tag-manager/gtmClient";
import { EventType } from "../lib/google-tag-manager/constants/eventType";
import { RED_PLANET_COOKIE_NAME } from "../constants/app";
import optimizelyClient, { isClientValid, OPTIMIZELY_FLAGS } from "../lib/optimizelyClient";
import Toaster from "../components/_global/Toaster";
var expireSessionTimeoutId = null;
var QOMApp = /*#__PURE__*/function (_App) {
  // The props comes from getInitialProps
  function QOMApp(props) {
    var _this;
    _classCallCheck(this, QOMApp);
    _this = _callSuper(this, QOMApp, [props]);
    // It assigns only one key value pair to 'pagesToasters' when a page first time landing
    // Any within app navigation (next/link) won't make server.use(getPageContent) get page data
    _initialiseProps.call(_this);
    _this.state = {
      pagesToasters: _defineProperty({}, pathNameHelper(props.router.asPath), props.toasters),
      hasOnFlag: false,
      isDone: false,
      isClientReady: null,
      projectId: null,
      showOutage: false
    };

    // store previous url
    _this.prevPath = /*#__PURE__*/React.createRef();
    // store urls a user has navigated
    _this.navHistory = /*#__PURE__*/React.createRef();
    // Initialize the navigation history
    _this.navHistory.current = [];
    return _this;
  }
  _inherits(QOMApp, _App);
  return _createClass(QOMApp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var _this$props$router = this.props.router,
        asPath = _this$props$router.asPath,
        events = _this$props$router.events;
      setMobileAppLandingPage(asPath);

      // Search for query parameter channel
      var parsed = queryString.parse(window.location.search);
      if (parsed.channel) {
        setChannel(parsed.channel);
      }
      this.OAuthLogin();
      var currentPath = pathNameHelper(asPath);
      // Initialize the navigation history,
      // the path will be pushed in if toaster for that path is fetched
      this.prevPath.current = currentPath;
      this.navHistory.current.push(currentPath);
      setToasterIndex(currentPath);
      setInterval(function () {
        return _this2.props.syncOffersViewedState();
      }, 10000);

      // HERC-530 prevent firing 'page-load' event after user goes back to (auth-callback and then) the same page after successful login
      var firePageLoadEvent = window.location.pathname !== window.sessionStorage.getItem('oauth_request_triggered_by');
      var isNotExceptionPage = !['link', 'partner-host', 'auth-callback'].some(function (path) {
        return window.location.pathname.includes(path);
      });
      if (isNotExceptionPage && firePageLoadEvent) {
        TrackingUtilities.trackPageView();
      }
      if (!window.location.pathname.includes('auth-callback')) {
        this.triggerPageViewEvent(asPath);
      }
      if (isNotExceptionPage) {
        window.sessionStorage.removeItem('oauth_request_triggered_by');
      }
      events.on('routeChangeComplete', this.routeChangeCompleteCb);
      this.props.router.beforePopState(function (_ref) {
        var as = _ref.as;
        window.location.href = as;
        window.location.reload();
      });
      if (typeof window !== 'undefined') {
        _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _window;
          var accessTokenExpiry, setAccessTokenExpiryRetry, _window2, _window3, expiryDateTime, expiresMilliSeconds;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  accessTokenExpiry = (_window = window) === null || _window === void 0 ? void 0 : _window.sessionStorage.getItem('accessTokenExpiry');
                  setAccessTokenExpiryRetry = 0; // if accessTokenExpiry is in the past, or accessTokenExpiry isn't set, wait for 5 seconds and retry
                case 2:
                  if (!(setAccessTokenExpiryRetry < 5 && (!accessTokenExpiry || parseInt(accessTokenExpiry, 10) < Date.now()))) {
                    _context.next = 9;
                    break;
                  }
                  setAccessTokenExpiryRetry += 1;
                  // eslint-disable-next-line no-await-in-loop
                  _context.next = 6;
                  return new Promise(function (resolve) {
                    return setTimeout(resolve, 5000);
                  });
                case 6:
                  accessTokenExpiry = (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.sessionStorage.getItem('accessTokenExpiry');
                  _context.next = 2;
                  break;
                case 9:
                  if (accessTokenExpiry && parseInt(accessTokenExpiry, 10) > Date.now()) {
                    expiryDateTime = parseInt(accessTokenExpiry, 10);
                    expiresMilliSeconds = expiryDateTime - Date.now() - 10000; // expire 10 seconds before actual expiry
                    if (expireSessionTimeoutId) {
                      clearTimeout(expireSessionTimeoutId);
                    }
                    expireSessionTimeoutId = (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.setTimeout(function () {
                      _this2.props.logoutViaExpire();
                    }, expiresMilliSeconds);
                  }
                case 10:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }))();
      }
      optimizelyClient.onReady().then(function () {
        _this2.setState({
          isDone: true
        });
        if (isClientValid()) {
          var datafile = JSON.parse(optimizelyClient.getOptimizelyConfig().getDatafile());
          var _optimizelyClient$dec = optimizelyClient.decide(OPTIMIZELY_FLAGS.SHO_SITE_WIDE_OUTAGE),
            showOutage = _optimizelyClient$dec.enabled;
          _this2.setState({
            isClientReady: true,
            projectId: datafile.projectId,
            showOutage: showOutage
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.router.events.off('routeChangeComplete', this.routeChangeCompleteCb);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props$user2,
        _this$props$user3,
        _this3 = this;
      var currentPath = pathNameHelper(this.props.router.asPath);

      // detect within app (next/Link) page transition
      if (this.prevPath.current !== currentPath) {
        this.prevPath.current = currentPath;
        setToasterIndex(currentPath);
        // and if the page hasn't been navigated to before, fetch page data
        if (this.navHistory.current.indexOf(currentPath) === -1) {
          this.fetchSetToasterMessage(currentPath);
        }
      }
      var _this$props$user = this.props.user,
        memberDetailsSyncInProgress = _this$props$user.memberDetailsSyncInProgress,
        memberDetailsSynced = _this$props$user.memberDetailsSynced;
      if (memberDetailsSynced || memberDetailsSyncInProgress) {
        return;
      }
      if ((_this$props$user2 = this.props.user) !== null && _this$props$user2 !== void 0 && _this$props$user2.authenticated || (_this$props$user3 = this.props.user) !== null && _this$props$user3 !== void 0 && _this$props$user3.authorized) {
        this.props.syncMemberDetails().then(function () {
          if (!['logout', 'auth-callback'].includes(_.trim(_this3.props.router.route, '/'))) {
            var _prevProps$user;
            _this3.props.openNewUserModal();
            _this3.props.openOptInModal();
            // Same page updates to authenticated
            if (_this3.prevPath.current === currentPath && !((_prevProps$user = prevProps.user) !== null && _prevProps$user !== void 0 && _prevProps$user.authenticated)) {
              _this3.triggerPageViewEvent(_this3.props.router.asPath);
            }
          }
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$user4;
      var _this$props = this.props,
        Page = _this$props.Component,
        pageProps = _this$props.pageProps,
        store = _this$props.store,
        router = _this$props.router;
      var userId = ((_this$props$user4 = this.props.user) === null || _this$props$user4 === void 0 ? void 0 : _this$props$user4.ffn) || 'anonymous_user';
      var optimizelyUser = {
        id: userId,
        attributes: {
          id: userId
        }
      };
      var currentPath = pathNameHelper(router.asPath);
      var toasters = this.state.pagesToasters[currentPath] || [];
      var hasToaster = Array.isArray(toasters) && toasters.length > 0;
      var showGlobalNav = true;
      // If outage flag is on, show outage page
      if (this.state.showOutage) {
        return __jsx(Outage, null);
      }
      var content = __jsx("main", {
        id: "page_content"
      }, __jsx(Page, _extends({}, pageProps, {
        prevPath: this.prevPath.current
      })), hasToaster && !getCurrentPath(currentPath).isDismissed && __jsx(Toaster, _extends({}, toasters[getToasterIndex(currentPath, toasters.length)], {
        currentPath: currentPath
      })));
      if (router.route === '/auth-callback') {
        return __jsx(OptimizelyProvider, {
          optimizely: optimizelyClient,
          user: optimizelyUser
        }, __jsx(Provider, {
          store: store
        }, __jsx("div", null, content, __jsx(MemberProfile, {
          visible: false
        }))));
      }
      if (router.route === '/shop') {
        return __jsx(OptimizelyProvider, {
          optimizely: optimizelyClient,
          user: optimizelyUser
        }, __jsx(Provider, {
          store: store
        }, __jsx("div", null, content, __jsx(MemberProfile, {
          visible: false
        }))));
      }
      if (router.route.startsWith('/login')) {
        return __jsx(OptimizelyProvider, {
          optimizely: optimizelyClient,
          user: optimizelyUser
        }, __jsx(Provider, {
          store: store
        }, __jsx("div", null, __jsx(MemberProfile, {
          visible: false
        }), content, __jsx(ImportantInfo, null), __jsx(SubFooter, null), __jsx(Footer, null))));
      }
      var fullView = true;
      if (['/card-offers-webview', '/laas-dashboard'].includes(router.route)) {
        fullView = false;
      }
      var header;
      if (router.route === '/link-card') {
        header = __jsx(LinkCardHeader, {
          showGlobalNav: showGlobalNav
        });
      } else {
        header = __jsx("div", null, fullView ? __jsx(GeneralHeader, {
          showGlobalNav: showGlobalNav,
          currentPath: currentPath,
          router: router
        }) : __jsx(MemberProfile, {
          visible: fullView
        }), fullView && __jsx(NavBar, {
          showGlobalNav: showGlobalNav
        }));
      }
      return __jsx(OptimizelyProvider, {
        optimizely: optimizelyClient,
        user: optimizelyUser
      }, __jsx(Provider, {
        store: store
      }, __jsx(ThemeProvider, {
        theme: baseTheme
      }, __jsx(GlobalStyles, {
        fullView: fullView
      }), __jsx("div", {
        className: "content"
      }, fullView && __jsx(SkipLinks, null), header, content, fullView && __jsx(ImportantInfo, {
        route: router.route
      }), fullView && __jsx(SubFooter, null), fullView && __jsx(Footer, null), __jsx(BrowserModal, null)))));
    }
  }], [{
    key: "getInitialProps",
    value: function () {
      var _getInitialProps = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
        var _ctx$req, _ctx$req2;
        var Component, ctx, content, toasters, pageProps, ipAddressStr;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                Component = _ref3.Component, ctx = _ref3.ctx;
                content = _.get(ctx, 'query.page.content', []);
                toasters = assembleToasters(content);
                pageProps = {};
                if (!Component.getInitialProps) {
                  _context2.next = 8;
                  break;
                }
                _context2.next = 7;
                return Component.getInitialProps(ctx);
              case 7:
                pageProps = _context2.sent;
              case 8:
                ipAddressStr = (ctx === null || ctx === void 0 ? void 0 : (_ctx$req = ctx.req) === null || _ctx$req === void 0 ? void 0 : _ctx$req.headers['x-forwarded-for']) || (ctx === null || ctx === void 0 ? void 0 : (_ctx$req2 = ctx.req) === null || _ctx$req2 === void 0 ? void 0 : _ctx$req2.connection.remoteAddress);
                pageProps.ipAddress = ipAddressStr ? ipAddressStr.split(/,\s*/)[0] : '';
                return _context2.abrupt("return", {
                  Component: Component,
                  pageProps: pageProps,
                  toasters: toasters
                });
              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      function getInitialProps(_x) {
        return _getInitialProps.apply(this, arguments);
      }
      return getInitialProps;
    }()
  }]);
}(App);
var _initialiseProps = function _initialiseProps() {
  var _this4 = this;
  this.OAuthLogin = function () {
    var _window4, _window4$sessionStora;
    if (window.location.href.includes('logout') || window.location.href.includes('auth-callback')) {
      return;
    }
    var user = _this4.props.user;
    var userInfoFromCookie = getOAuthUserInfoFromCookie();
    var accessTokenFromCookie = getLslAccessTokenFromCookie();
    var qlffWlSessCookie = getLslSessionToken();
    var loginCancelled = (_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$sessionStora = _window4.sessionStorage) === null || _window4$sessionStora === void 0 ? void 0 : _window4$sessionStora.getItem('login_cancelled');
    if (!(user !== null && user !== void 0 && user.authenticated) && userInfoFromCookie && accessTokenFromCookie && (qlffWlSessCookie || config.IS_IT_LOCAL)) {
      var lastName = userInfoFromCookie.lastName,
        firstName = userInfoFromCookie.firstName,
        ffn = userInfoFromCookie.ffn,
        points = userInfoFromCookie.points;
      var loginDetails = {
        authenticated: true,
        firstName: firstName,
        lastName: lastName,
        ffn: ffn,
        points: points,
        accessToken: accessTokenFromCookie
      };
      _this4.props.setUserAuthenticatedOnRefresh(loginDetails);
    } else if (!userInfoFromCookie && qlffWlSessCookie !== null && !config.IS_IT_LOCAL && !loginCancelled) {
      // HERC-478 only if the lsAccessToken cookie is present, but no session info present redirect
      // to oauth login page which should automatically log the user in
      redirectToOauthLoginPage(window.location.href, false); // doesn't enforce login.
    } else if (userInfoFromCookie && qlffWlSessCookie === null && !config.IS_IT_LOCAL) {
      // HERC-478 if user is removed the cookie due to logout from other *.qantas.com, log him out
      // from here as well.
      logoutFromLsl();
    }
  };
  this.triggerPageViewEvent = function (url) {
    var _this4$props$user;
    var cookies = new Cookies();
    var event = createEvent({
      type: EventType.PAGE_VIEW,
      payload: {
        qffHashId: cookies.get(RED_PLANET_COOKIE_NAME),
        pathName: url,
        isLoggedIn: (_this4$props$user = _this4.props.user) === null || _this4$props$user === void 0 ? void 0 : _this4$props$user.authenticated
      }
    });
    track(event);
  };
  this.routeChangeCompleteCb = function (url) {
    _this4.props.syncShoSession();

    // Special tracking for EDR to wait for flags within their pages.
    if (!['link', 'partner-host'].some(function (path) {
      return url.includes(path);
    })) {
      TrackingUtilities.trackPageView(url);
    }
    _this4.triggerPageViewEvent(url);
  };
  this.setHasOnFlag = function (value) {
    _this4.setState({
      hasOnFlag: value
    });
  };
  this.fetchSetToasterMessage = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(path) {
      var response, _pages$data, pages, pageContent, _pages$data$page$cont, content;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return fetch("/page".concat(path), {
                method: 'GET',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                }
              });
            case 3:
              response = _context3.sent;
              if (!(response.status === 200)) {
                _context3.next = 12;
                break;
              }
              _context3.next = 7;
              return response.json();
            case 7:
              pages = _context3.sent;
              _this4.navHistory.current.push(path);
              pageContent = null;
              if (pages !== null && pages !== void 0 && (_pages$data = pages.data) !== null && _pages$data !== void 0 && _pages$data.page) {
                _pages$data$page$cont = pages.data.page.content, content = _pages$data$page$cont === void 0 ? [] : _pages$data$page$cont;
                pageContent = assembleToasters(content);
              }
              _this4.setState(function (prevState, props) {
                return {
                  pagesToasters: _objectSpread(_objectSpread({}, prevState.pagesToasters), {}, _defineProperty({}, pathNameHelper(props.router.asPath), pageContent))
                };
              });
            case 12:
              _context3.next = 17;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](0);
              console.warn('Unable to fetch the toaster message for this page');
            case 17:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 14]]);
    }));
    return function (_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var stateToProps = function stateToProps(_ref4) {
  var user = _ref4.user;
  return {
    user: user
  };
};
var mapDispatchToProps = {
  syncOffersViewedState: syncOffersViewedState,
  syncMemberDetails: syncMemberDetails,
  syncShoSession: syncShoSession,
  setUserAuthenticatedOnRefresh: setUserAuthenticatedOnRefresh,
  expireLslSession: expireLslSession,
  openNewUserModal: openNewUserModal,
  openOptInModal: openOptInModal,
  logoutViaExpire: logoutViaExpire
};
export default withApollo(withRedux(connect(stateToProps, mapDispatchToProps)(QOMApp)));